import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-dvh place-items-center p-4 text-center">
      <div>
        <h1 className="mb-2 text-2xl font-bold">{t('errors.notFound.title')}</h1>
        <p className="mb-4 text-tenue">{t('errors.notFound.body')}</p>
        <Link to="/" className="text-acento">{t('errors.notFound.back')}</Link>
      </div>
    </div>
  );
}
